import React from 'react';
import Retailer from './Retailer.js';

function Retailers(props) {
  const retailers = props.retailers;
  const stores1 = retailers.deliveryMatches.map((retailer) =>
      <Retailer key={retailer.name} retailer={retailer} deliveryMatch={true} destZipcode={props.destZipcode}/>
  );
  const stores2 = retailers.deliveryMisses.map((retailer) =>
      <Retailer key={retailer.name} retailer={retailer} deliveryMatch={false} destZipcode={props.destZipcode}/>
  );
  return (
    <div className="retailers">{stores1}{stores2}</div>
  );
}

Retailers.propTypes = {
  destZipcode: React.PropTypes.string,
  retailers: React.PropTypes.object.isRequired,
}

export default Retailers



// WEBPACK FOOTER //
// ./src/components/retailers/Retailers.js